// The receipt templates (A4 portrait `A4-1`, landscape paper book `L-1`), generated from the voucher
// prototype, plus the QR library they draw with. Needs css/paper.css and @xr/ui's css/dirham.css.
import qrcode from 'qrcode-generator';
import { XV } from './xv.gen.js';

// the engine draws a real, scannable QR when the library is on the page (as in the prototypes)
(globalThis as unknown as { qrcode: typeof qrcode }).qrcode = qrcode;

export { XV };
export type { Paper, VoucherModel, XvLogo } from './xv.gen.js';
